module.exports = __webpack_public_path__ + "static/media/Turkey-banner.5ca24509.svg";